import React from 'react';

/**
 * SelectField component - handles select/dropdown input type
 */
function SelectField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <select
            id={fieldId}
            value={value || ''}
            onChange={(e) => onChange(index, e.target.value)}
            className="w-full px-3 py-2 bg-surface-2 text-content border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-amber"
        >
            <option value="">Selecciona...</option>
            {field.options && field.options.map((option, optIndex) => {
                const optionValue = typeof option === 'string' ? option : option.value;
                const optionLabel = typeof option === 'string' ? option : option.label;
                return (
                    <option key={optIndex} value={optionValue}>
                        {optionLabel}
                    </option>
                );
            })}
        </select>
    );
}

export default SelectField;
